import { useMemo } from 'react'
import {
  shopTypeToIdMap,
  ShopType,
  getShopTypeLabelFromShopType,
} from '~/lib/shopType'
import { FilterList, FilterListItem } from './FilterList'

type Props = {
  selectedShopType?: ShopType
  buildUrl: (shopType: ShopType) => string
}

export const ShopTypeFilter: React.FC<Props> = ({
  selectedShopType = 'all',
  buildUrl,
}) => {
  const selectedLabel = getShopTypeLabelFromShopType(selectedShopType)
  const conditions = useMemo(
    () =>
      Object.keys(shopTypeToIdMap).map((key) => {
        return {
          label: getShopTypeLabelFromShopType(key),
          href: buildUrl(key),
        }
      }),
    [buildUrl]
  )

  return (
    <div className="flex flex-col gap-y-[2px]">
      <h3 className="text-[18px] text-black-400">店舗タイプ</h3>
      <FilterList>
        <FilterListItem
          label={selectedLabel}
          href={buildUrl(selectedShopType)}
          conditions={conditions}
          selectedLabelOnPopup={selectedLabel}
        />
      </FilterList>
    </div>
  )
}
